export const formatError = (error, t) => {
  const { response = {} } = error;
  const { status } = response;
  if (status === 400) {
    return t('COMMON:VERIFICATION_INVALID_CODE');
  }
  return t('COMMON:GENERIC_ERROR');
}
